module.exports = __webpack_public_path__ + "img/capusta-logo-compressed--black.216f9554.svg";